"use strict";

(function (Drupal, once) {
  Drupal.behaviors.permalink = {
    attach: function attach(context, settings) {
      var permalink = document.querySelectorAll('.permalink');
      if (!permalink.length) {
        return;
      }
      once('permalinkProcessed', '.permalink', context).forEach(function () {
        var permaLink = $(this);
        // Copy permalink to clipboard.
        permaLink.addEventListener('click', function (event) {
          event.preventDefault();
          var copyInput = document.createElement('input');
          copyInput.setAttribute('type', 'textfield');
          copyInput.setAttribute('size', '1');
          document.body.appendChild(copyInput);
          copyInput.value = window.location.href;
          copyInput.select();
          document.execCommand('copy');
          document.body.removeChild(copyInput);
        });
      });
    }
  };
})(Drupal, once);